module.exports = __webpack_public_path__ + "media/images/parceiros_pagamentos/resized/mercado-pago-logo-58e9221aa2b682e2fa433c80b489784c.svg";